import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { createElement } from "@wordpress/element";

/** @format */

/**
 * External dependencies
 */
import { Component } from '@wordpress/element';
import PropTypes from 'prop-types';
import { Spinner } from '@wordpress/components';
/**
 * `ChartPlaceholder` displays a large loading indiciator for use in place of a `Chart` while data is loading.
 */

var ChartPlaceholder =
/*#__PURE__*/
function (_Component) {
  _inherits(ChartPlaceholder, _Component);

  function ChartPlaceholder() {
    _classCallCheck(this, ChartPlaceholder);

    return _possibleConstructorReturn(this, _getPrototypeOf(ChartPlaceholder).apply(this, arguments));
  }

  _createClass(ChartPlaceholder, [{
    key: "render",
    value: function render() {
      var height = this.props.height;
      return createElement("div", {
        "aria-hidden": "true",
        className: "woocommerce-chart-placeholder",
        style: {
          height: height
        }
      }, createElement(Spinner, null));
    }
  }]);

  return ChartPlaceholder;
}(Component);

ChartPlaceholder.propTypes = {
  height: PropTypes.number
};
ChartPlaceholder.defaultProps = {
  height: 0
};
export default ChartPlaceholder;
//# sourceMappingURL=placeholder.js.map